/** Shared surface / text tokens — auth pages + app shell (keep in sync). */

export const DARK_SURFACE = {
  bgDefault: "#050505",
  bgPaper: "#0c0c0c",
  textPrimary: "#FFFFFF",
  textSecondary: "#9CA3AF",
  divider: "rgba(255,255,255,0.05)",
  footerText: "rgba(255,255,255,0.87)",
  footerBg: "#050505",
  inputBg: "rgba(255,255,255,0.03)",
};

export const LIGHT_SURFACE = {
  bgDefault: "#F7FAFC",
  bgPaper: "#FFFFFF",
  textPrimary: "#1A202C",
  textSecondary: "#4A5568",
  divider: "rgba(0,0,0,0.1)",
  footerText: "#4A5568",
  footerBg: "#F7FAFC",
  inputBg: "rgba(0,0,0,0.01)",
};
